module.exports = __webpack_public_path__ + "img/MultiStrikeDarkMode.cafa889a.svg";